<template>
    <modal :show.sync=show :modalClasses="{ 'calculator-modal': true, 'medium-sized-modal': Object.keys(tableData).length === 0 }" bodyClasses="p-0" :hide-footer="true" @close="resetForm()">
        <h3 slot="header" class="mb-0 font-weight-500">Property Income Eligible</h3>

        <div v-loading="loading" class="p-4">
            <ValidationObserver v-slot="{ invalid }" ref="observer">
                <b-form ref="propertyIncomeForm" role="form" @submit.prevent="calculate()">
                    <b-row v-show="Object.keys(tableData).length === 0">
                        <b-col cols="12" md="6">
                            <b-form-group label="Age">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'age'"
                                >
                                    <b-form-input
                                    v-model="form.age"
                                    type="text"
                                    maxlength="3"
                                    @keydown="preventNonNumericInput"
                                    required
                                    ></b-form-input>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6">
                            <b-form-group label="Commitment Amount">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'commitmentAmount'"
                                >
                                    <CurrencyInput
                                        v-model="form.commitment_amount"
                                        :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                                    />
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6">
                            <b-form-group label="Property Value">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'propertyValue'"
                                >
                                    <CurrencyInput
                                        v-model="form.property_value"
                                        :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                                    />
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols="12">
                            <PropertyIncomeEligibleTable v-show="Object.keys(tableData).length > 0" :tableData="tableData" />
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="6" sm="12" class="mx-auto text-center mt-3 pt-2">
                            <b-button type="submit" variant="primary" :disabled="invalid" v-show="Object.keys(tableData).length === 0">Calculate</b-button>
                            <b-button variant="primary" @click.prevent="resetForm">Reset</b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </ValidationObserver>
        </div>
    </modal>
</template>
<script>
import Modal from '@/components/Modal'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import '@/assets/js/formValidations.js'
import CurrencyInput from '@/components/CurrencyInput'
import {
  notifyFunctionMixin,
  helperFunctionMixin,
  axios,
  services,
  getHeader
} from '@/assets/js/httpImports.js'
import PropertyIncomeEligibleTable from '@/views/Calculators/CalculatorsTables/PropertyIncomeEligibleTable'

export default {
    props: {
        property_income_eligible: Boolean
    },
    mixins:[ notifyFunctionMixin, helperFunctionMixin ],
    components: {
        Modal,
        ValidationObserver,
        ValidationProvider,
        CurrencyInput,
        PropertyIncomeEligibleTable
    },
    data() {
        return {
            loading: false,
            form: {
                age: 30,
                commitment_amount: '',
                living_costs: 1300,
                property_value: 500000,
                loan_margin: 90,
                interest_rate_percent: 4.2
            },
            tableData: {},
        }
    },
    computed: {
        show: {
            get() {
                return this.property_income_eligible;
            },
            set(newVal) {
                this.$emit('update:property_income_eligible', newVal);
            },
        },
    },
    methods: {
        preventNonNumericInput(event) {
            const keyCode = event.keyCode || event.which;
            const keyValue = String.fromCharCode(keyCode);
            const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
            const allowedKeys = [8, 37, 38, 39, 40, 46];
            if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
                event.preventDefault();
            }
        },
        calculate() {
            this.loading = true
            axios.post(services.calculatorNew + '/calculator/property-loan', this.form, { headers: getHeader() })
            .then(res => {
                this.tableData = res.data
                this.loading = false
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
        resetForm() {
            this.form = {
                age: 30,
                commitment_amount: '',
                living_costs: 1300,
                property_value: 500000,
                loan_margin: 90,
                interest_rate_percent: 4.2
            }

            this.tableData = {}
        }
    }
}
</script>